<template>
  <v-container fluid>
    <v-form ref="leaveForm"  @submit.prevent  v-model="isLeaveFormValid" >
      <v-row>
        <v-col cols="12" md="4">        
            <v-autocomplete
              clearable
              label="Employee name"
              :items="employees"
              variant="outlined"
              item-value="EMPMST_DOCNO"
              item-text="EMPMST_NAME"
              v-model="selectedEmployee"
              @change="get_AllLeaves()"
              >          
              <template #selection="{ item }">
                <v-list-item-content>
                  <v-list-item-title v-text="item.EMPMST_NAME"></v-list-item-title>
                  <!-- <v-list-item-subtitle>({{ item.EMPMST_DOCNO }}) </v-list-item-subtitle> -->
                </v-list-item-content>
              </template>
              <template v-slot:item="{ item }">
                <v-list-item-avatar>
                  <!-- Use employee photo if available, otherwise use mdi-account icon as the avatar -->
                  <v-img v-if="item.EMPMST_PHOTO" :src="item.EMPMST_PHOTO"></v-img>
                  <v-icon v-else>mdi-account</v-icon>
                </v-list-item-avatar>
              <v-list-item-content>
                  <v-list-item-title v-text="item.EMPMST_NAME"></v-list-item-title>
                  <v-list-item-subtitle v-text="item.EMPMST_DOCNO"></v-list-item-subtitle>
              </v-list-item-content>
              </template>
              <template v-slot:no-data>
                  <v-list-item>
                      <v-list-item-content>
                      <v-list-item-title>
                          No Data Available - 
                          <span @click="get_employees" style="color: blue; cursor:pointer;">Get Employees</span>
                      </v-list-item-title>
                      </v-list-item-content>
                  </v-list-item>
              </template>
            </v-autocomplete>
          </v-col>
        <v-col cols="4" md ="4" sm="6">
          <v-text-field label="Employee Code" v-model="employ_id" :rules="EmployeeCodeRules" disabled />
        </v-col>
        <v-col cols="8" md ="4" sm="6">
          <v-text-field label="Employee Name" v-model="employee_name" :rules="EmployeeNameRules" disabled />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6">
          <v-autocomplete
            :items="leavetypes" 
            item-text = "PLV_DESC"
            label="Leave Type"
            :rules="leaveTypeRules"
            v-model="selectedLeaveType"
            return-object
          >
            <template #selection="{ item }">
              <v-list-item-content>
                <v-list-item-title v-text="item.PLV_DESC"></v-list-item-title>     
              </v-list-item-content>
            </template>
            <template #item="{ item }">
              <v-list-item-content>
                <v-list-item-title v-if="displayedLeaveTypes.includes(item.PLV_DESC)">
                  {{ item.PLV_DESC }}
                </v-list-item-title>
                <v-list-item-title v-else :class="{ 'grey--text': true }">
                  {{ item.PLV_DESC }}
                </v-list-item-title>
                <v-list-item-subtitle> Days (Max days {{ item.PLV_ELIGIBLE_DAYS }})</v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            v-if="selectedLeaveType"
            label="Leave Utilized" 
            disabled   
            :suffix="`/ ${selectedLeaveType ? selectedLeaveType.PLV_ELIGIBLE_DAYS : '0'} days`"
            :value="leaveSummary[selectedLeaveType ? selectedLeaveType.PLV_DESC : ''] + ' days'"           
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="4">
          <v-dialog
            ref="from_date_dialog"
            v-model="fromdateModal"      
            :return-value.sync="date"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="fromDate"
                label="From Date"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                :rules="fromDateRules"
                @input="numberOfLeaveDays"
              ></v-text-field>
            </template>
              <v-date-picker
                  v-model="fromDate"        
                  scrollable
              >
                  <v-spacer></v-spacer>
                  <v-btn
                  text
                  color="primary"
                  @click="fromdateModal = false"
                  >
                  Cancel
                  </v-btn>
                  <v-btn
                  text
                  color="primary"
                  @click="$refs.from_date_dialog.save(fromDate)"
                  >
                  OK
                  </v-btn>
              </v-date-picker>
          </v-dialog>
        </v-col>
        <v-col cols="12" sm="4">
          <v-dialog
            ref="to_date_dialog"
            v-model="todateModal"
            :return-value.sync="date"
            persistent
            width="290px"
            >
            <template v-slot:activator="{ on, attrs }">
                <v-text-field
                v-model="toDate"
                label="To Date"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                :rules="toDateRules"
                @input="numberOfLeaveDays"
                ></v-text-field>
            </template>
            <v-date-picker
                v-model="toDate"
                scrollable
                >
                <v-spacer></v-spacer>
                <v-btn
                text
                color="primary"
                @click="todateModal = false"
                >
                Cancel
                </v-btn>
                <v-btn
                text
                color="primary"
                @click="$refs.to_date_dialog.save(toDate)"
                >
                OK
                </v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
        <v-col cols="6" sm="2">
          <v-checkbox 
              v-model="isHalfDaySelected" 
              label="Half Day"
              :disabled="!isHalfDay"
              >
          </v-checkbox>
        </v-col>
        <v-col cols="6" sm="2">
            <v-text-field
            label="Requesting Leave Days"
            v-model="numberOfLeaveDays" 
            :rules="remainingdaysRules"        
            />
        </v-col>     
      </v-row> 
      <v-row>
        <v-col cols="12" sm="8">
          <v-textarea
            v-model="remarks"
            label="Leave Reason:"
            rows="1"
            :counter="50"
            :rules="remarksRules"
          ></v-textarea>
        </v-col>
        <v-col cols="12"  sm="4"> 
          <v-text-field 
            label="Created By" 
            v-model="user.USER_NAME" 
            :rules="EmployeeNameRules" 
            disabled 
          />          
        </v-col>
      </v-row>
      <v-row>      
        <v-col cols="12" sm="6"  class="text-center">
            <v-btn 
            color="primary"
            dark        
            type="submit"
            @click="submitLeaveRequest"       
            >
            {{ isSubmitting ? 'Submitting...' : 'Submit' }}       
            </v-btn>
        </v-col>
        
      </v-row>
      <v-row justify="space-between">
        <v-col cols="4">
          <v-btn block :disabled="!isLeaveFormValid || isSubmitting" color="primary" type="submit">
            {{ isSubmitting ? 'Submitting...' : 'Submit' }}
          </v-btn>
        </v-col>
        <v-col cols="4">
          <v-btn color="error" block @click="resetForm">Reset</v-btn>
        </v-col>
        <v-col cols="4">
          <v-btn color="warning" block @click="goback">Cancel</v-btn>
        </v-col>
      </v-row>   
    </v-form>
  </v-container>
</template>
<script>
import moment from 'moment';
import secure_axios from "../services/secure_axios";

export default {

data() {
  return {
    date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    minDate: new Date(new Date().setDate(new Date().getDate() - 2)),
    selectedLeaveTypesFilter: [],
    leaveTypes: [],
    selectedLeaveType: null ,
    selectedEmployee:"",
    fromDate: null,
    toDate: null,
    remarks: '', 
    fromdateModal: false,
    todateModal:false,
    selectedleave: null,
    showPopup: false,
    from_date_dialog:false,
    to_date_dialog:false,
    isHalfDaySelected: false,
    new_leave_dialog:false,
    showLeaveForm: false,
    isSubmitting: false,
    isLeaveFormValid :false,
    utilizedLeaveDays: 0,
    
  };
}, 
watch:{
  selectedLeaveType(){       
    this.$forceUpdate(this.remainingdaysRules);
  },
  selectedEmployee(newValue, oldValue) {
    if (newValue !== oldValue) {
        this.fetchLeaveTypes(newValue);
    }
  }
} ,
computed: {
  sessionAPI() {
    return this.$store.getters.sessionAPI
  },
  perferedAPI() {
    return this.$store.getters.perferedAPI; // default API
  },
  numberOfLeaveDays: {
    get() {
    if (this.fromDate && this.toDate) {
      const start = moment(this.fromDate);
      const end = moment(this.toDate);
      const days = end.diff(start, 'days') + 1;
      return this.isHalfDaySelected && this.isHalfDay ? days -0.5 : days;
    }
    return 0; },  
    set() {
    }   
  },
  user(){     
    return this.$store.getters.factsuser;      
  },
  filteredLeaves() {
      if (this.selectedLeaveTypesFilter.length === 0) {
          return this.allleaves; // No filter selected, show all
      }
      return this.allleaves.filter(leave => 
          this.selectedLeaveTypesFilter.includes(this.getLeaveTypeName(leave.ABS_ABSENT_TYPE_DOCNO))
      );
  },
  userProfile(){
    return this.$store.getters.userProfile;
  },
  leaveFormData(){
    return this.$store.getters.leaveFormdata;
  },
  allleaves(){
    return this.$store.getters.allleaves;
  },
  leavetypes(){
    return this.$store.getters.leavetypes;
  }, 
  employ_id(){
    if (this.selectedEmployee) {
      return this.selectedEmployee;
    } else {
      return this.user.USER_EMP_DOCNO;
    }
  },  
  employee_name()  {
    if (this.selectedEmployee) {      
      return `${this.employees.find(type => type.EMPMST_DOCNO === this.selectedEmployee)?.EMPMST_NAME}`
    } else {
      return `${this.userProfile.EMPMST_NAME }`
    }
  },    
  // leaveSummary() {
  //     const allLeaves = this.allleaves;
  //     const leaveTypes = this.leavetypes;

  //     let totalTaken = 0;  // Initialize total leaves taken
  //     const summary = {};

  //     leaveTypes.forEach(type => {
  //     const typeId = type.PLV_DOCNO;
  //     const typeName = type.PLV_DESC;
  //     const takenDays = allLeaves.reduce((total, leave) => {
  //         return leave.ABS_ABSENT_TYPE_DOCNO === typeId ? total + leave.ABS_ABSENT_DAYS : total;
  //     }, 0);

  //     if (takenDays > 0) {  // Only include leave types that have been used
  //         summary[typeName] = takenDays;
  //         totalTaken += takenDays;  // Sum up total taken days
  //     }
  //     });

  //     return { summary, totalTaken };
  // },
  leaveSummary() {
    const summary = this.leavetypes.reduce((acc, type) => {
      acc[type.PLV_DESC] = this.allleaves.filter(leave => leave.ABS_ABSENT_TYPE_DOCNO === type.PLV_DOCNO)
                                        .reduce((sum, { ABS_ABSENT_DAYS }) => sum + ABS_ABSENT_DAYS, 0);
      return acc;
    }, {});
    return summary;
  },
  availableCasualLeave(){      
    return 7.0 - parseFloat(this.leaveSummary["Casual leave"])
  },
  availableSickLeave(){
    return 7.0 - parseFloat(this.availableCasualLeave[ "Sick Leave"])
  },    
  isHalfDay() {
    return this.fromDate && this.toDate && this.fromDate === this.toDate;
  },
  displayedLeaveTypes() {
    return ["Casual leave", "Sick Leave", "Absent (Loss of pay B)","Compensatory Leave"];
  },
  availableCompensatoryLeaves(){
    return this.$store.getters.compensatoryLeaves;
  },
  EmployeeCodeRules (){
    return [
      v => !!v || 'EmployeeCode type is required',
    ]
  },
  EmployeeNameRules (){
    return [
      v => !!v || 'EmployeeName type is required',
    ]
  },
  leaveTypeRules (){
    return [
      v => !!v || 'Leave type is required',
      v => this.displayedLeaveTypes.includes(v) || 'Only allowed to select enabled leave types',
      // v => v==="Casual leave"? this.availableCasualLeave >= this.numberOfLeaveDays|| `This leave type over the limit ${this.v}` : true,
      // v => v==="Sick Leave"? this.availableSickLeave >= this.numberOfLeaveDays|| `This leave type over the limit ${this.v}` : true,
      // v => {
      //   if(v=='Casual leave' && this.numberOfLeaveDays <= this.availableCasualLeave ){
      //     return `You only have ${this.availableCasualLeave} days of Casual leave left`;}
      //   else if (v == 'Sick Leave' &&  this.availableSickLeave >= this.leaveDays ) {
      //     return `You only have ${this.availableSickLeave} days of Sick Leave left`;} 
      //   else {
      //     return true;}
      // }
    ]
  },
  fromDateRules () {
    return [
      v => !!v || 'From date is required',
      v => new Date(v) >= this.minDate || 'Allowed only to request from last day on app' ,
      v => this.toDate ? v <= this.toDate || 'From date must be on or before to date' : true,        
    ]
  },
  toDateRules () {
    return [
      v => !!v || 'To date is required',
      v => this.fromDate ? v >= this.fromDate || 'To date must be on or after from date' : true,
    ]
  },
  remarksRules () {
    return [
      v => !!v || 'Remarks is required',
      v => (v && v.length >= 15 && v.length <= 50) || 'Remarks must be between 15 and 50 characters',
      // v => !/(.)\1/.test(v) || 'Remarks cannot have repeated characters',
      v => !/[^a-zA-Z0-9\s]/.test(v) || 'Remarks cannot contain special characters'
    ]
  },
  remainingdaysRules(){
    return[
      v=> !!v || 'required',
      v => v >= 0 || 'Leave days cannot be negative',
      v=> v <= this.remainingLeaveDays() ||`${this.selectedLeaveType } max ${this.remainingLeaveDays() } days`,
      v=> v == this.numberOfLeaveDays ||  'Leave days should match the count from and to date',
    ]
  },
  employees(){
    return this.$store.getters.employees
  },
},
methods: {
  get_AllLeaves(isReset=false){
    this.$store.dispatch("getAllLeaves", { employ_id:this.employ_id, isReset  })
  },
  async get_CompensatoryLeaves(){     
    await this.$store.dispatch("getCompensatoryLeaves", { employ_id:this.employ_id  })
  },
  async get_employees(){
    await this.$store.dispatch("get_employee", { employ_id: this.user.USER_EMP_DOCNO})
    await this.$store.dispatch("get_employees", { employ_id: this.user.USER_EMP_DOCNO ,EMPMST_DESG_DOCNO:this.userProfile.EMPMST_DESG_DOCNO,dep:this.userProfile.EMPMST_UD_TXT5,USER_LOGINID:this.user.USER_LOGINID})
  },
  toggleLeaveTypeFilter(leaveType) {
      const index = this.selectedLeaveTypesFilter.indexOf(leaveType);
      if (index > -1) {
      this.selectedLeaveTypesFilter.splice(index, 1); // Remove if already selected
      } else {
      this.selectedLeaveTypesFilter.push(leaveType); // Add if not selected
      }
  },
  resetLeaveTypeFilter() {
      this.selectedLeaveTypesFilter = []; // Reset the filter to show all leaves
  },
  // fetchLeaveTypes(){
  //    this.$store.dispatch("getAllLeaves")
  // },
  fetchLeaveTypes(employ_id = null) {
      // Construct the URL based on whether employ_id is provided
    let url = '/leavetypes';
      if (employ_id) {
        url += `?employ_id=${employ_id}`;
      }
      secure_axios.get(url).then(response => {
      this.leaveTypes = response.data;
      }).catch(error => {
      console.error('Error fetching leave types:', error);
      });
  },
  initFormData(){
    if(this.leaveFormData !== null && this.leaveFormData !== undefined){
      // console.log(this.leaveFormData)
      let leave_data = this.leaveFormData
      // console.log(leave_data.ABS_NARRATION)
      this.selectedLeaveType = leave_data.ABS_NARRATION
      this.fromDate = leave_data.ABS_FROMDATE
      this.toDate = leave_data.ABS_TODATE
      this.remarks = leave_data.remarks
      // console.log(this.remarks)
      }
  },
  resetForm() {  },
  goback() {
    this.$router.push('/myleaves');
  },
  openNewLeaveForm() {
      // Reset the form data or initialize defaults here if necessary
      this.initFormData();
      // Open the dialog
      this.new_leave_dialog = true;
  },
  setleaveFormData(){
    const leave_data = {
      ABS_EMP_DOCTYPE:this.userProfile.EMPMST_DOCTYPE,
      ABS_EMP_DOCNO:this.employ_id,
      ABS_FROMDATE:this.fromDate,
      ABS_TODATE:this.toDate,
      ABS_NARRATION:this.remarks,
      ABS_CREATED_BY:this.user.USER_LOGINID,
      ABS_ABSENT_TYPE_DOCNO:this.getLeaveTypeNo(this.selectedLeaveType),
      ABS_ABSENT_DAYS:this.numberOfLeaveDays,
      ABS_PAYMENT_FACTOR:this.getLeavePaymentfactor(this.selectedLeaveType),
      // selectedLeaveType : this.selectedLeaveType
    };
    // console.log(this.userProfile.EMPMST_DOCTYPE)
      this.$store.dispatch("setleaveFormdata", leave_data)
    return leave_data;
  },
  checkAllRules() {
    const leaveTypeValid = this.leaveTypeRules.every(rule => rule(this.selectedLeaveType)===true);
    const fromDateValid = this.fromDateRules.every(rule => rule(this.fromDate) === true);
    const toDateValid = this.toDateRules.every(rule => rule(this.toDate)=== true);
    const remarksValid = this.remarksRules.every(rule => rule(this.remarks) === true);
    if(leaveTypeValid && fromDateValid && toDateValid && remarksValid){
      this.setleaveFormData();
      return true ;
    }else {
      return false;
    }
  },
  postleaveRequest(){      
    const asyncpostLeave= async () => {
        this.$store.dispatch("getLoading", true);    
        try {
          const resp = await secure_axios.post(this.perferedAPI + "leaves", {
           leave_data:this.leaveFormData,             
          });
          const data = resp.data
          const status = resp.status
          console.log(data)
          console.log(status)
          if(status==201){              
            this.new_leave_dialog= false;
            this.$store.dispatch("clearleaveFormdata")
            this.get_AllLeaves();
            this.isSubmitting = false;
          }          
        } catch (err) {
        // Handle Error Here
        console.error(err);
        this.$store.dispatch("getError", err);
      }
      
      this.$store.dispatch("getLoading", false);
      this.msgdialog = true;
      }
      asyncpostLeave();
  },
  // async submitLeaveRequest1(){  
  //   this.$refs.leaveForm.validate(valid => {
  //    if (valid) {
  //      // form is valid, submit the data
  //     console.log('Form is valid')
  //    } else {
  //      // form is not valid, show error message
  //      console.log('Form is not valid')
  //    }
  //  })
  //   this.setleaveFormData(); 
  //   if (this.checkAllRules()) { 
  //     this.isSubmitting = true
  //     this.postleaveRequest();         
  //   }       
  //},
  submitLeaveRequest() {
  if (this.$refs.leaveForm.validate()) {
    // Your submission logic here
    this.setleaveFormData(); 
     if (this.checkAllRules()) { 
       this.isSubmitting = true
       this.postleaveRequest();         
     }   
  } else {
    // Handle validation errors
  }
 },
  getLeaveTypeName(leaveTypeNo) {
    let leaveType = this.leavetypes.find(type => type.PLV_DOCNO === leaveTypeNo);
    return leaveType ? leaveType.PLV_DESC : '';
  },
  getLeaveTypeNo(leaveTypeName) {
    let leaveType= this.leavetypes.find(type => type.PLV_DESC === leaveTypeName);
    return leaveType ? leaveType.PLV_DOCNO : '';
  },
  getLeavePaymentfactor (leaveTypeName) {
  let leaveType= this.leavetypes.find(type => type.PLV_DESC === leaveTypeName);
  return leaveType ? leaveType.PLV_PAYMENT_FACTOR : '';
  },    
  formatDate(date){
    return moment(date).format('DD-MM-YYYY').toString()
  },
  statusInfo(leave){
    if(leave.ABS_POSTED_TS && leave.ABS_POSTED_BY){
      return `Posted By : ${leave.ABS_POSTED_BY} on:${ this.formatDate(leave.ABS_POSTED_TS)} `
    }else{
      return"Processing"
    }
  },
  // cardClass() {
  //   return `flip-card ${this.leave.status === 'processing' ? 'processing-card' : 'approved-card'}`;
  // },
  statuscolor(leave){
    return ` ${this.statusInfo(leave) === 'processing' ? 'yellow' : 'green'}`
  },
  availableMaxLeave(leaveType){
    // console.log('avl',leaveType)
    if (leaveType === "Compensatory Leave"){        
      if (this.availableCompensatoryLeaves !== undefined  && this.availableCompensatoryLeaves  !== null)        
        return parseInt(this.availableCompensatoryLeaves.reduce((sum, obj) => sum + obj.COM_ABSENT_DAYS, 0));
      else return 0
    }else{
    return parseInt(this.leavetypes.find(type => type.PLV_DESC === leaveType)?.PLV_ELIGIBLE_DAYS)
    }
  },

  remainingLeaveDays() {
    if (this.selectedLeaveType !='Absent (Loss of pay)'){
      let MaxLeave = this.availableMaxLeave(`${this.selectedLeaveType}`)
      let UsedLeave = this.leaveSummary[`${this.selectedLeaveType}`]
      let totalLeaveDays = MaxLeave- parseFloat(UsedLeave)
      return(totalLeaveDays)        
    }else{
      return 10
    }
  }, 

},    
created () {
  this.get_AllLeaves();
  this.get_CompensatoryLeaves();
  this.initFormData();
  // this.$store.dispatch("getAllLeaves");
  this.$store.dispatch("getLeaveTypes");
  if(!(this.userProfile == null || this.userProfile == undefined)){
    this.$store.dispatch("get_employee", { employ_id: this.user.USER_EMP_DOCNO })
    // this.get_employees();
  }
},
mounted() {    
  this.initFormData();
},
}
</script>

  